import { Injectable } from '@angular/core';

import { RoutingService, GlobalMessageService, User, GlobalMessageType } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, pluck, map } from 'rxjs/operators';
import {UserAccountFacade} from '@spartacus/user/account/root';

@Injectable({
    providedIn: 'root',
  })
  export class UigAdminGuard  {

    ADMIN_USER = 'admin_user';

    constructor(
      protected userAccountFacade: UserAccountFacade,
      protected routingService: RoutingService,
      protected globalMessageService: GlobalMessageService
    ) {}
  
    canActivate(): Observable<boolean> {
      return this.userAccountFacade.get().pipe(
        filter((user: User) => user && Object.keys(user).length > 0),
        pluck('roles'),
        map((roles: string[]) => {
          const hasRole =
            Array.isArray(roles) && roles.includes(this.ADMIN_USER);
  
          if (!hasRole) {
            this.routingService.go({ cxRoute: 'organization' });
  
            this.globalMessageService.add(
              { key: 'organization.notification.noSufficientPermissions' },
              GlobalMessageType.MSG_TYPE_WARNING
            );
          }
  
          return hasRole;
        })
      );
    }
  }
